module.exports = __webpack_public_path__ + "img/ico_curtain_2.7a5d92a1.png";